var map = {
	"./black/luxiangjilu2.png": "GK/W",
	"./blue/luxiangjilu2.png": "31zD",
	"./white/luxiangjilu2.png": "rvD9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26Ug";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/luxiangjilu2\.png$
// module id = 26Ug
// module chunks = 24